<template>
  <div>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <Table
        style="margin-top: 20px;"
        stripe
        border
        :columns="columns1"
        :loading="modal_loading"
        :data="dataTable"
        width="100%"
        @on-row-click="rowClick"
      >
      </Table>
      <div
        style="display: flex; align-items: center; justify-content: space-between;margin-top:20px"
      >
        <Button type="primary" @click="addData()">追加</Button>
        <Page
          :total="this.totalNum"
          style="display: flex;justify-content: flex-end"
          @on-change="pageChange"
        />
      </div>
    </Card>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <p slot="title">{{ datileTitle }}</p>
      <Form
        :model="formItem"
        :label-width="110"
        label-position="left"
        :disabled="form_loading"
        ref="formValidate"
        :rules="ruleValidate"
        style="margin-top:20px"
      >
        <FormItem
          :label="lang == 'zh' ? chNameMap[val] : enNameMap[val]"
          v-for="(val, key) in sortfMap"
          :key="val"
          style="margin-right: 50px;"
          v-if="showSelfData[val] == '1'"
          :prop="
            val == 'filename'
              ? 'filename'
              : val == 'description'
              ? 'description'
              : ''
          "
        >
          <div v-if="val == 'filename'" style="display:flex;flex-wrap: wrap;">
            <Upload
              :action="action"
              ref="my-upload"
              :on-success="uploadSuccess"
              :show-upload-list="false"
              style="margin-right:30px"
            >
              <Button icon="ios-cloud-upload-outline">选择文件</Button>
            </Upload>
            <span>{{ formItem[val] }}</span>
          </div>
          <Input
            v-else-if="val == 'description'"
            type="textarea"
            v-model="formItem[val]"
            style="min-width: 260px;"
            :disabled="disableSelfData[val] == 0"
          />
          <Input
            v-else
            v-model="formItem[val]"
            style="min-width: 260px;"
            :disabled="disableSelfData[val] == 0"
          />
        </FormItem>
      </Form>
    </Card>
    <div class="bottomBtn">
      <Button type="primary" v-if="!form_loading" @click="saveData()"
        >保存</Button
      >
      <Button v-if="plan" @click="returnPage()" style="margin-left: 15px"
        >返回</Button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "@/util/DateUtil";
import watermark from "@/util/watermark";

export default {
  data() {
    return {
      date: new DateUtil(),
      userId: "",
      plan: "",
      id: "",
      modal_loading: false,
      form_loading: true,
      formItem: {
        description: "",
        filename: ""
      },
      datileTitle: "附加文件",
      totalNum: 0, //table数据总条数
      pageInfo: {
        pageNo: 1, //页码
        pageSize: 10, //每页数据条数
        itemCount: 4 //总条数
      },
      action: "/api/resource/upload",
      chNameMap: {},
      enNameMap: {},
      disableSelfData: {},
      dataTable: [],
      addState: false,
      ruleValidate: {
        description: [{ required: true, message: "描述不能为空" }],
        filename: [{ required: true, message: "请上传附件" }]
      },
      sortfMap: {},
      showSelfData: {}
    };
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    },
    getWaterMarkStatus() {
      return this.$store.getters.getWaterMarkStatus == 1
        ? watermark.addWaterMark()
        : "";
    },
    columns1() {
      let column = [
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.creatdate
              : this.enNameMap.creatdate,
          key: "creatdate",
          minWidth: 200,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.creatdate, "YYYY-MM-DD")
            );
          }
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.description
              : this.enNameMap.description,
          key: "description",
          minWidth: 300
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.filename
              : this.enNameMap.filename,
          key: "filename",
          minWidth: 350
        }
      ];
      let arr = [];
      arr = column.filter(item => {
        return this.showSelfData[item.key] == 1;
      });
      return arr;
    }
  },
  created() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userId = userInfo.serialnumber;
  },
  methods: {
    getData(id, plan) {
      (this.plan = plan ? plan : ""), (this.id = id);
      this.getTableData();
    },
    getTableData() {
      let obj = {
        sheetId: this.id,
        serialnumber: this.plan ? this.plan : this.userId,
        bePersonal: this.plan ? "0" : "1",
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize
      };
      this.modal_loading = true;
      axios
        .post("/document/searchUserDocumentInfo", obj)
        .then(res => {
          this.modal_loading = false;
          // this.form_loading=false
          if (res) {
            this.formItem = {};
            this.chNameMap = res.chNameMap;
            this.enNameMap = res.enNameMap;
            this.totalNum = Number(res.pageInfo.total);
            this.dataTable = res.data;
            this.disableSelfData = res.disableSelfData;
            this.showSelfData = res.showSelfData;
            this.sortfMap = res.sortfMap;
            delete this.sortfMap[11];
          }
        })
        .catch(err => {
          this.$Message.info(err);
        });
    },
    rowClick(row, index) {
      this.datileTitle = "附加文件";
      this.form_loading =
        this.disableSelfData.DocumentsList == "0" ? true : false;
      this.formItem = JSON.parse(JSON.stringify(row));
      this.addState = false;
      this.formItem.creatdate = this.date.dateVal(row.creatdate, "YYYY-MM-DD");
    },
    addData() {
      this.form_loading = false;
      this.datileTitle = "新增附加文件";
      this.formItem = {
        description: "",
        filename: ""
      };
      this.addState = true;
      this.formItem.creatdate = this.date.dateVal(new Date(), "YYYY-MM-DD");
    },
    saveData() {
      this.$refs["formValidate"].validate(valid => {
        if (valid) {
          this.$Modal.confirm({
            title: this.$notice("sureSave"),
            content: "",
            onOk: () => {
              let saveItem = JSON.parse(JSON.stringify(this.formItem));
              let obj = {
                serialnumber: this.plan ? this.plan : this.userId,
                ...saveItem
              };
              this.modal_loading = true;
              if (this.addState) {
                axios
                  .post("/document/uploadUserDocumentInfo", obj)
                  .then(res => {
                    this.modal_loading = false;
                    if (res) {
                      this.$Message.info(res);
                      this.getTableData();
                    }
                  })
                  .catch(err => {
                    this.$Message.info(err);
                  });
              } else {
                axios
                  .post("/document/updateUserDocumentInfo", obj)
                  .then(res => {
                    this.modal_loading = false;
                    if (res) {
                      this.$Message.info(res);
                      this.getTableData();
                    }
                  })
                  .catch(err => {
                    this.$Message.info(err);
                  });
              }
            },
            onCancel: () => {}
          });
        }
      });
    },
    uploadSuccess(item, file) {
      this.formItem.filename = file.name;
      this.formItem.resourceId = item.data;
      console.log(this.formItem);
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getTableData();
    },
    returnPage() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.formRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.formCol {
  width: calc((100% - 210px) / 2);
  float: left;
  /* margin-right: 30px; */
}
.formColT {
  width: calc(100% - 210px);
  float: left;
  /* margin-right: 30px; */
}
@media screen and (max-width: 1300px) and (min-width: 800px) {
  .formCol {
    width: calc((100% - 210px) / 2);
  }
  .formColT {
    width: calc((100% - 40px));
  }
}
@media screen and (max-width: 800px) {
  .formCol {
    width: 100%;
  }
  .formColT {
    width: 100%;
  }
}
.bottomBtn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.ivu-date-picker {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/components/DocumentsList.vue